import React, { Component } from "react";
import "./OrderTracking.css";
import Footer from "../../component/Footer/Footer";
import LayoutWrapper from "../../component/LayoutWrapper/";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import PropTypes from "prop-types";
import {
  trackingOrder,
  doOrderTrackingRes,
} from "../../action/OrderTrackingAction";
import loaderImg from "../../assets/images/loader-example.gif";
import Loader from "react-loader-advanced";
// import fedex from '../../assets/images/fedex.jpg';
import moment from "moment";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

class OrderTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoader: false,
      trackingId: "1904192521703",
      shipment_track: [],
      shipment_track_activities: [],
    };
    ReactGA.initialize("UA-64201999-5");
    ReactGA.pageview(window.location.pathname + window.location.search);

    ReactPixel.init("784849368913134");

    ReactPixel.pageView();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.doOrderTrackingRes && nextProps.doOrderTrackingRes.user) {
      if (
        nextProps.doOrderTrackingRes.user &&
        nextProps.doOrderTrackingRes.user.OrderTrackingRes
      ) {
        if (
          nextProps.doOrderTrackingRes.user.OrderTrackingRes &&
          nextProps.doOrderTrackingRes.user.OrderTrackingRes.track_status === 1
        ) {
          this.setState({
            shipment_track:
              nextProps.doOrderTrackingRes.user.OrderTrackingRes
                .shipment_track[0],
            shipment_track_activities:
              nextProps.doOrderTrackingRes.user.OrderTrackingRes
                .shipment_track_activities,
            isLoader: false,
          });
        } else {
          this.setState({
            isLoader: false,
          });
        }
      }
    }
  }

  componentDidMount() {
    const data = {
      trackingId: this.state.trackingId,
    };
    this.setState({
      isLoader: true,
    });
    this.props.trackingOrder(data);
  }

  logOut = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  render() {
    // const content = this.state.checked
    const spinner = (
      <span>
        <img src={loaderImg} alt="" />
      </span>
    );
    return (
      <React.Fragment>
        <Loader show={this.state.isLoader} message={spinner}>
          <LayoutWrapper />

          <main className="main">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <div className="container">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/order-history">Order History</a>
                  </li>
                  {/* <li className="breadcrumb-item"><a href="/order-details">Order Details</a></li> */}
                  <li className="breadcrumb-item active" aria-current="page">
                    Order Tracking
                  </li>
                </ol>
              </div>
              {/* End .container  */}
            </nav>
            <div className="container">
              <div className="row">
                <div className="col-lg-9 order-lg-last dashboard-content">
                  <h2>Order Tracking</h2>
                  <div>
                    <div className="hp_cards_info">
                      <div className="clearfix  delievery_status">
                        <div className="pull-left status_cont">
                          <div className="status_check clearfix">
                            <span>Delivered On</span>
                            <div className="edd_info">
                              <span
                                style={{ display: "inline" }}
                                className="edd_day"
                                id="edd_day"
                              >
                                {moment(
                                  this.state.shipment_track.delivered_date
                                ).format("dddd")}
                              </span>
                              <strong className="edd_month" id="edd_month">
                                {moment(
                                  this.state.shipment_track.delivered_date
                                ).format("MMMM")}
                              </strong>
                              <strong className="edd_date" id="edd_date">
                                {moment(
                                  this.state.shipment_track.delivered_date
                                ).format("DD")}
                                <span className="year_txt">
                                  {moment(
                                    this.state.shipment_track.delivered_date
                                  ).format("YYYY")}
                                </span>
                              </strong>
                            </div>
                          </div>
                          <span id="shipment_status_label">Status:</span>
                          <strong id="shipment_status">
                            <i className="check_delievery"></i>
                            {this.state.shipment_track.current_status}
                          </strong>
                        </div>
                      </div>
                    </div>

                    <div className="">
                      <div className="courier_info clearfix">
                        {/* <div className="pull-left courier_logo" style ={ { backgroundImage: "url("+fedex+")" ,backgroundRepeat: 'no-repeat'} }></div>
                                                <div className="pull-left">
                                                    <span>
                                                        <b>Fedex</b>
                                                    </span>
                                                </div> */}
                        <div className="pull-right">
                          <span>
                            <b>Tracking ID</b>
                          </span>
                          <span className="tracking_id">
                            {this.state.shipment_track.awb_code}
                          </span>
                        </div>
                      </div>
                      <div className="delievery_info ">
                        <div className="delievery_list_wrap clearfix">
                          <ul>
                            {this.state.shipment_track_activities &&
                              this.state.shipment_track_activities.map(
                                (item, i) => (
                                  <li className="active" key={i}>
                                    <span>
                                      <b>Activity : </b>
                                      <activity>{item.activity}</activity>
                                    </span>
                                    <span>
                                      <b>Location : </b>
                                      <activity>{item.location}</activity>
                                    </span>
                                    {/* <!-- Delivered or RTO delivered -->
                                                                    <!-- <i className="check_delievery"></i> -->
                                                                    <!-- undelivered --> */}
                                    <div className="date_info_wrap">
                                      <span className="date">
                                        {moment(item.date).format("DD")}{" "}
                                        {moment(item.date).format("MMM")}
                                      </span>
                                      <span className="time">
                                        {moment(item.date).format("LT")}
                                      </span>
                                    </div>
                                    <i className="circle_icon"></i>
                                  </li>
                                )
                              )}

                            {/* <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>On FedEx vehicle for delivery - OD</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>INDORE - 452001</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">29 Dec</span>
                                                                <span className="time">11:45 AM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>At local FedEx facility - AR</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>INDORE - 452001</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">29 Dec</span>
                                                                <span className="time">10:02 AM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>In transit - IT</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>INDORE - 453771</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">29 Dec</span>
                                                                <span className="time">07:10 AM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>In transit - IT</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>INDORE - 453771</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">29 Dec</span>
                                                                <span className="time">02:00 AM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>In transit - IT</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>INDORE - 453771</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">29 Dec</span>
                                                                <span className="time">02:00 AM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>In transit - IT</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>BHIWANDI - 421302</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">27 Dec</span>
                                                                <span className="time">08:23 AM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>In transit - IT</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>BHIWANDI - 421302</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">27 Dec</span>
                                                                <span className="time">12:58 AM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>In transit - IT</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>NASIK - 422005</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">26 Dec</span>
                                                                <span className="time">08:39 PM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>Left FedEx origin facility - DP</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>NASIK - 422005</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">26 Dec</span>
                                                                <span className="time">08:38 PM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>Shipment information sent to FedEx - OC</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>NA</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">24 Dec</span>
                                                                <span className="time">04:31 AM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                <b>Activity : </b>
                                                                <activity>Order Received</activity>
                                                            </span>
                                                            <span>
                                                                <b>Location : </b>
                                                                <activity>Indore</activity>
                                                            </span>
                                                            <div className="date_info_wrap">
                                                                <span className="date">24 Dec</span>
                                                                <span className="time">03:56 PM</span>
                                                            </div>
                                                            <i className="circle_icon"></i>
                                                        </li> */}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End .col-lg- */}

                <aside className="sidebar col-lg-3">
                  <div className="widget widget-dashboard">
                    <h3 className="widget-title">My Account</h3>

                    <ul className="list">
                      <li>
                        <a href="/profile-update">Account Details</a>
                      </li>
                      <li>
                        <a href="/my-wallet">My Wallet</a>
                      </li>
                      <li>
                        <a href="/address-info">Address Info</a>
                      </li>
                      <li>
                        <a href="/change-password">Change-Password</a>
                      </li>

                      <li className="active">
                        <a href="/order-history">My Order</a>
                      </li>
                      <li><a href="/corporate-order-history">Corporate Order</a></li>
                      <li>
                        <span
                          className="logoutLi"
                          onClick={() => this.logOut()}
                        >
                          Logout
                        </span>
                      </li>
                    </ul>
                  </div>
                  {/* End .widget */}
                </aside>
                {/* End .col-lg-3 */}
              </div>
              {/* End .row */}
            </div>
            {/* End .container  */}
            <div className="mb-5"></div>
            {/* margin  */}
          </main>
          {/* End .main */}
        </Loader>
        <Footer />
      </React.Fragment>
    );
  }
}

OrderTracking.propTypes = {
  doOrderTrackingRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  doOrderTrackingRes: doOrderTrackingRes,
});

function mapDispatchToProps(dispatch) {
  return {
    trackingOrder: (data) => dispatch(trackingOrder(data)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(OrderTracking);
